import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL_BASE + "api/trade/";

class TradeService {
  addTrade = async (tradeData) => {
    try {
      const res = await axios.post(API_URL + "addTrade", { tradeData }, { headers: authHeader() });
      return res;
    } catch (err) {
      throw new Error(err.response.data.message || "Something wnt wrong");
    }
  };

  getTrades = async (data) => {
    const queryParams = new URLSearchParams({
      order: data.order,
      sort: data.sort,
      page: data.page,
      itemsPerPage: data.itemsPerPage,
    });
    try {
      const res = await axios.get(API_URL + `getTrades?${queryParams.toString()}`, {
        headers: authHeader(),
      });
      console.log(res);
      return res.data;
    } catch (error) {
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  scaleIn = async (data) => {
    const config = {
      method: "post",
      url: `${API_URL}scaleIn`,
      data: data,
      headers: authHeader(),
    };

    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  scaleOut = async (data) => {
    const config = {
      method: "post",
      url: `${API_URL}scaleOut`,
      data: data,
      headers: authHeader(),
    };

    try {
      const response = await axios(config);
      console.log(response);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  deleteTrade = async (id) => {
    const config = {
      method: "delete",
      url: `${API_URL}${id}`,
      headers: authHeader(),
    };
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  deleteTradeJournal = async () => {
    const config = {
      method: "delete",
      url: `${API_URL}`,
      headers: authHeader(),
    };
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  resetTrade = async (tradeId) => {
    const config = {
      method: "put",
      url: `${API_URL}reset-trade/${tradeId}`,
      headers: authHeader(),
    };
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  getTradeById = async (id) => {
    const config = {
      method: "get",
      url: `${API_URL}${id}`,
      headers: authHeader(),
    };
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  getTradesByTicker = async (ticker) => {
    console.log("fun");
    const config = {
      method: "get",
      url: `${API_URL}ticker-trades/${ticker}`,
      headers: authHeader(),
    };
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  updateTrade = async (data) => {
    console.log(data);
    const config = {
      method: "put",
      url: `${API_URL}${data._id}`,
      data: data,
      headers: authHeader(),
    };
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  editScaleIn = async (data) => {
    const config = {
      method: "put",
      url: `${API_URL}edit-scale-in/${data.tradeId}`,
      data: data,
      headers: authHeader(),
    };
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  editScaleOut = async (data, tradeId) => {
    const config = {
      method: "put",
      url: `${API_URL}edit-scale-out/${data.tradeId}`,
      data: data,
      headers: authHeader(),
    };
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  deleteSacleIn = async (data) => {
    console.log(data);
    const config = {
      method: "post",
      url: `${API_URL}delete-scale-in`,
      data: data,
      headers: authHeader(),
    };
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };

  deleteSacleOut = async (data) => {
    console.log(data);
    const config = {
      method: "post",
      url: `${API_URL}delete-scale-out`,
      data: data,
      headers: authHeader(),
    };
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
      throw new Error(error.response.data.message || "Something wnt wrong");
    }
  };
}

export default new TradeService();
